module.exports = __webpack_public_path__ + "img/clients-courtyard.c3c592bf.png";